import { render, staticRenderFns } from "./partsRowTable.vue?vue&type=template&id=bc5b72d4&scoped=true&"
import script from "./partsRowTable.vue?vue&type=script&lang=js&"
export * from "./partsRowTable.vue?vue&type=script&lang=js&"
import style0 from "./partsRowTable.vue?vue&type=style&index=0&id=bc5b72d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5b72d4",
  null
  
)

export default component.exports